import { useEffect } from "react";
import Lenis from "lenis";
import { motion, useScroll, useSpring } from "framer-motion";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Chapters from "@/components/Chapters";
import NotifyForm from "@/components/NotifyForm";
import Footer from "@/components/Footer";
import RoseVine from "@/components/RoseVine";

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 28, mass: 0.4 });
  return (
    <motion.div
      style={{ scaleX }}
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[70] bg-gradient-to-r from-[#D88C9A] via-[#D4AF37] to-[#E0A3AC]"
    />
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#FDFBF7] text-[#2C2421] font-sans antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <ScrollProgress />
      <RoseVine />
      <Hero />
      <Marquee />
      <Chapters />
      <NotifyForm />
      <Footer />
    </div>
  );
}

export default App;
